import { isHTMLContentEmpty } from "helpers/common";
import { dateRequiredSchema, stringRequiredSchema, urlRequiredSchema } from "utils/validation/validationHelpers";
import { object, string } from 'yup';

const workshopSchema = object().shape({
    title: stringRequiredSchema,
    date: dateRequiredSchema,
    description: string()
        .test('is-not-empty', 'This field is required', (value) => !isHTMLContentEmpty(value))
        .required('This field is required'),
    link: urlRequiredSchema,
});

export default workshopSchema;